/**
 * Stable CSS class names for E2E — pages_ro/Installment (InstallmentOptionManagement).
 * Covers the page, the filter/insert/edit drawers, and the confirm dialog.
 * Containers use `installment-option__<element>`; inputs and user-interactable
 * controls use `installment-option-input--<name>`.
 */
export const IOM = {
    page: 'installment-option-page',
    root: 'installment-option',
    loading: 'installment-option__loading',

    /* --- Page header --------------------------------------------------- */
    breadcrumb: 'installment-option__breadcrumb',

    /* --- Empty state (initial country picker) -------------------------- */
    emptyState: 'installment-option__empty-state',
    emptyInfo: 'installment-option__empty-info',
    emptyImage: 'installment-option__empty-image',
    emptyText: 'installment-option__empty-text',
    emptyForm: 'installment-option__empty-form',
    emptyCountryField: 'installment-option__empty-country-field',
    inputEmptyCountry: 'installment-option-input--empty-country',
    emptyCountryOption: 'installment-option__empty-country-option',
    emptyFilterAction: 'installment-option__empty-filter-action',
    btnEmptyFilter: 'installment-option-input--button-empty-filter',
    emptyDetailedAction: 'installment-option__empty-detailed-action',
    btnEmptyDetailed: 'installment-option-input--button-empty-detailed',

    /* --- Data list ----------------------------------------------------- */
    dataList: 'installment-option__data-list',
    dataListTitleBox: 'installment-option__data-list-title-box',
    dataListTitle: 'installment-option__data-list-title',
    toolbarActions: 'installment-option__toolbar-actions',
    btnAddNew: 'installment-option-input--button-add-new',
    btnAddNewInner: 'installment-option-input--button-add-new-inner',
    btnOpenFilter: 'installment-option-input--button-open-filter',
    toolbarStatusControl: 'installment-option__toolbar-status-control',
    inputToolbarStatus: 'installment-option-input--toolbar-status',
    toolbarStatusOption: 'installment-option__toolbar-status-option',
    toolbarStatusOptionEmpty: 'installment-option__toolbar-status-option--empty',

    chipsLabelBox: 'installment-option__chips-label-box',
    chipsLabel: 'installment-option__chips-label',
    chipsBox: 'installment-option__chips-box',
    chipsStack: 'installment-option__chips-stack',
    chip: 'installment-option__chip',
    chipCountry: 'installment-option__chip--country',
    chipCreditCardType: 'installment-option__chip--credit-card-type',
    chipNumberOfInstallment: 'installment-option__chip--number-of-installment',
    chipStatus: 'installment-option__chip--status',

    grid: 'installment-option__grid',

    /* --- Grid cells ---------------------------------------------------- */
    cellStatus: 'installment-option__cell-status',
    inputCellStatusSwitch: 'installment-option-input--cell-status-switch',
    cellCreditCardTypeId: 'installment-option__cell-credit-card-type-id',
    cellRegionName: 'installment-option__cell-region-name',
    cellCreditCardTypeName: 'installment-option__cell-credit-card-type-name',
    cellInstallments: 'installment-option__cell-installments',
    cellInstallmentChip: 'installment-option__cell-installment-chip',
    cellActions: 'installment-option__cell-actions',
    btnRowMenu: 'installment-option-input--button-row-menu',
    rowMenu: 'installment-option__row-menu',
    rowMenuItem: 'installment-option__row-menu-item',
    rowMenuItemEdit: 'installment-option__row-menu-item--edit',
    rowMenuItemDelete: 'installment-option__row-menu-item--delete',

    /* --- Filter drawer ------------------------------------------------- */
    filterDrawer: 'installment-option__filter-drawer',
    filterForm: 'installment-option__filter-form',
    filterHeader: 'installment-option__filter-header',
    filterFieldCountry: 'installment-option__filter-field-country',
    inputFilterCountry: 'installment-option-input--filter-country',
    filterCountryOption: 'installment-option__filter-country-option',
    filterFieldBank: 'installment-option__filter-field-bank',
    inputFilterBank: 'installment-option-input--filter-bank',
    filterBankOption: 'installment-option__filter-bank-option',
    filterFieldNumberOfInstallments: 'installment-option__filter-field-number-of-installments',
    inputFilterNumberOfInstallments: 'installment-option-input--filter-number-of-installments',
    filterInstallmentOption: 'installment-option__filter-installment-option',
    filterFieldStatus: 'installment-option__filter-field-status',
    inputFilterStatus: 'installment-option-input--filter-status',
    filterStatusOption: 'installment-option__filter-status-option',
    filterStatusOptionEmpty: 'installment-option__filter-status-option--empty',
    filterActionsBox: 'installment-option__filter-actions-box',
    btnFilterSubmit: 'installment-option-input--button-filter-submit',

    /* --- Insert drawer ------------------------------------------------- */
    insertDrawer: 'installment-option__insert-drawer',
    insertForm: 'installment-option__insert-form',
    insertHeader: 'installment-option__insert-header',
    insertFieldCountry: 'installment-option__insert-field-country',
    inputInsertCountry: 'installment-option-input--insert-country',
    insertCountryOption: 'installment-option__insert-country-option',
    insertFieldBank: 'installment-option__insert-field-bank',
    inputInsertBank: 'installment-option-input--insert-bank',
    insertFieldNumberOfInstallments: 'installment-option__insert-field-number-of-installments',
    inputInsertNumberOfInstallments: 'installment-option-input--insert-number-of-installments',
    insertInstallmentOption: 'installment-option__insert-installment-option',
    insertActionsBox: 'installment-option__insert-actions-box',
    btnInsertSubmit: 'installment-option-input--button-insert-submit',

    /* --- Edit drawer --------------------------------------------------- */
    editDrawer: 'installment-option__edit-drawer',
    editForm: 'installment-option__edit-form',
    editHeader: 'installment-option__edit-header',
    editFieldCountry: 'installment-option__edit-field-country',
    inputEditCountry: 'installment-option-input--edit-country',
    editCountryOption: 'installment-option__edit-country-option',
    editFieldBank: 'installment-option__edit-field-bank',
    inputEditBank: 'installment-option-input--edit-bank',
    editBankOption: 'installment-option__edit-bank-option',
    editFieldNumberOfInstallments: 'installment-option__edit-field-number-of-installments',
    inputEditNumberOfInstallments: 'installment-option-input--edit-number-of-installments',
    editInstallmentOption: 'installment-option__edit-installment-option',
    editFieldStatus: 'installment-option__edit-field-status',
    inputEditStatus: 'installment-option-input--edit-status',
    editStatusOption: 'installment-option__edit-status-option',
    editActionsBox: 'installment-option__edit-actions-box',
    btnEditSubmit: 'installment-option-input--button-edit-submit',

    /* --- Confirm dialog ------------------------------------------------ */
    confirmDialog: 'installment-option__confirm-dialog',
    confirmDialogTitle: 'installment-option__confirm-dialog-title',
    confirmDialogContent: 'installment-option__confirm-dialog-content',
    confirmDialogContentText: 'installment-option__confirm-dialog-content-text',
    confirmDialogActions: 'installment-option__confirm-dialog-actions',
    btnConfirmReject: 'installment-option-input--button-confirm-reject',
    btnConfirmAccept: 'installment-option-input--button-confirm-accept',
} as const;

export const iomCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
